export function mapNullable<T, U>(n: T | null, f: (a: T) => U): U | null {
    return n == null ? <null>n : f(n);
}

export function cloneNullable<T extends Record<string, unknown>>(
    n: T | null
): T | null {
    return mapNullable(n, (v) => ({ ...(<any>v) }));
}

export function lengthOr0<T>(items: T[]): number {
    return mapNullable(items, () => items.length) || 0;
}
